jQuery(($) => {
	$('body').foundation();
	const context = $('body');
	setFooterPush();
	hasScrollbar();
	checkRatio();
	initGalleries(context);
	initIFrameResizer(context);
	setPlaybuttonPosition();

	// 100vh fix for iOs
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", vh + "px");

	$(window).on("resize", function () {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", vh + "px");
		setPlaybuttonPosition();
	});

	$(".toggle-nav-main").on("click", function () {
		if ($(this).hasClass("active")) {
			$("body").removeClass("no-scroll");
		} else {
			$("body").addClass("no-scroll");
		}
	});

	/*
	 * Resize handler
	 */
	$(window)
		.once("dealer:window.resize")
		.on(
			"resize",
			throttle(function () {
				hasScrollbar();
				setFooterPush();
				checkRatio();
			}, 250)
		);

	/*
	 * Scroll to Element
	 */
	$('a[href*="#"]', context)
		.not('[href="#"]')
		.not('[href="#0"]')
		.not("a.disable-smooth-scroll")
		.click(function (event) {
			if (
				location.pathname.replace(/^\//, "") ==
				this.pathname.replace(/^\//, "") &&
				location.hostname == this.hostname
			) {
				var target = $(this.hash);
				target = target.length
					? target
					: $("[name=" + this.hash.slice(1) + "]");
				if ($(this).closest(".stage-slider-fullscreen").length) {
					target = target.length
						? target
						: $(this)
							.closest(".layout__region.layout__region--content")
							.find("> div")
							.filter(
								(key, value) =>
									$(value).find(".stage-slider-fullscreen").length
							)
							.first()
							.next();
				}
				if (target.length) {
					var scrollTarget = target;
					var offset = 150;
					if (target.is("select:hidden")) {
						scrollTarget = target.next(".chosen-container");
					}
					if (target.is("section.bg-white")) {
						offset += parseInt(
							target.find(".page-content").css("margin-top")
						);
					}
					event.preventDefault();

					// Close menu before scroll
					$(".js-toggle.toggle-nav-main.active .action-close").trigger(
						"click"
					);

					$("html, body").animate(
						{
							scrollTop: scrollTarget.offset().top - offset,
						},
						600,
						function () {}
					);
				}
			}
		});

	/*
	 * Accordion: Open/Close all
	 */
	$(".js-accordion-open-all , .js-accordion-close-all", context).on(
		"click",
		function () {
			var open = $(this).is(".js-accordion-open-all");
			var close = $(this).is(".js-accordion-close-all");

			var $container = $(this).closest(".accordion-container");
			var $accordion = $container.find(".accordion");
			var $content = $accordion.find(".accordion-content");

			$accordion.foundation(open ? "down" : "up", $content);

			if (open) {
				$container.find(".js-accordion-open-all").hide();
				$container.find(".js-accordion-close-all").show();
			} else if (close) {
				$container.find(".js-accordion-open-all").show();
				$container.find(".js-accordion-close-all").hide();
			}

			return false;
		}
	);

	if ($(".js-accordion-open-all , .js-accordion-close-all", context).length) {
		$(".accordion-title", context).on("click", function () {
			var $container = $(this).closest(".accordion-container");

			if ($container.find(".accordion-item:not(.is-active)").length) {
				var open = false;
			} else {
				var open = true;
			}

			if (open) {
				$container.find(".js-accordion-open-all").hide();
				$container.find(".js-accordion-close-all").show();
			} else {
				$container.find(".js-accordion-open-all").show();
				$container.find(".js-accordion-close-all").hide();
			}
		})
	}

	/*
	 * Slider
	 */

	// Init slider play/pause controls
	$('.slider-fullscreen, .teaser-img-twothird-slider, .google-review-slider', context).on('init breakpoint', function(event, slick) {
		addSliderPlayButton(this, slick);
	});

	// Resize Slider if toggle link was clicked
	$(".google-review-slider", context).on("click", ".js-toggle", function () {
		setTimeout(function(element) {
			$(element).closest(".google-review-slider").slick("refresh");
			var slick = $(element).closest(".google-review-slider").slick("getSlick");
			addSliderPlayButton($(element).closest(".google-review-slider")[0], slick);
		}, 400, this);
	});


	$(".slider-default", context).slick(getSliderOptions("default"));
	$(".slider-fullscreen:not(.slick-initialized)", context).slick(getSliderOptions("fullscreen"));
	// Fix for lightbox trigger in fullscreen slider: The slider gets rebuilt after breakpoint change, so the events must be appended again
	$(".slider-fullscreen", context).on("breakpoint", function () {
		initLightboxes($(this));
	});
	$(".teaser-img-twothird-slider", context).slick(
		getSliderOptions("teaserimgtwothirdslider")
	);
	$(".image-teaser-slider", context).slick(
		getSliderOptions("teaserimgslider")
	);
	$(".video-slider", context).slick(getSliderOptions("video"));

	$(".slider-navigation .js-toggle-slide-select", context).on(
		"click",
		function () {
			toggleSlideMenu($(this).closest(".slider-navigation").find("ul"));
		}
	);
	$(".slider-navigation .js-go-to-slide", context).on("click", function () {
		var slide = $(this).data("slide");
		var $slider = $(this)
			.closest(".slider-container")
			.find(".slider-with-navigation");
		goToSlide($slider, slide);
		toggleSlideMenu($(this).closest(".slider-navigation").find("ul"));
	});
	$(".slider-with-navigation").on(
		"beforeChange",
		function (event, slick, currentSlide, nextSlide) {
			var $slide = $(this).find(".slick-slide.slick-current .slide");

			updateSliderNavigation($(this), nextSlide);
		}
	);

	// Prevent Scrolling when mobile menu is active
	$(".toggle-nav-main .action-open").click(function (e) {
		e.preventDefault();
		$("body").css("overflow", "hidden");
	});

	$(".toggle-nav-main .action-close").click(function (e) {
		e.preventDefault();
		$("body").css("overflow", "auto");
	});
	$(".google-review-slider", context).slick(
		getSliderOptions("googlereviewslider")
	);

	/*
	 * Show YouTube video on preview image click
	 */
	$(".youtube-play")
		.once("dealer:youtube-play")
		.on("click", function (event) {
			var $previewContainer = $(this).closest(".youtube-preview-container");
			var $iframeContainer = $previewContainer.find(
				".youtube-iframe-container"
			);
			var iframeSrc = $iframeContainer.data("iframeSrc");
			var iframeTitle = $iframeContainer.data("iframeTitle");

			var $iframe = $("<iframe/>")
				.attr("src", iframeSrc)
				.attr("title", iframeTitle)
				.attr("allowfullscreen", "true");

			$previewContainer.find(".youtube-preview-image").remove();
			$(this).remove();
			$iframeContainer.show().append($iframe);

			event.preventDefault();
			return false;
		});

	initLightboxes(context);

	/**
	 * Open second navi level (mobile)
	 */
	$(".nav-main .main-item.with-submenu > a", context)
		.once("dealer:nav-open-submenu")
		.on("click", function () {
			// Only do something if the mobile version of the nav is currently displayed
			if (!$(".toggle-nav-main").is(":visible")) {
				return;
			}

			$(".nav-sub, .nav-sub-models").removeClass("open");
			$(this).next(".nav-sub, .nav-sub-models").addClass("open");

			return false;
		});

	/**
	 * Close second navi level (mobile)
	 */
	$(".nav-main .js-close-submenu", context)
		.once("dealer:nav-close-submenu")
		.on("click", function () {
			$(this).closest(".nav-sub, .nav-sub-models").removeClass("open");
			return false;
		});

	/*
	 * Preselect form value
	 */
	$(".js-form-preselect", context).on("click", function () {
		var select = $(this).data("select");
		var value = $(this).data("value");
		var selectValue = value;

		if ($(select).prop("multiple")) {
			selectValue = $(select).val()
				? $.merge($(select).val(), [value])
				: value;
		}

		$(select).val(selectValue).trigger("chosen:updated");

		// Scroll to form
		$("html, body").animate(
			{
				scrollTop: $(select).closest("form").offset().top - 200,
			},
			600
		);
	});

	/**
	 * Scroll to form on submit button click
	 */
	$("input:submit.js-scroll-to-form", context).on("click", function () {
		// Scroll to form
		$("html, body").animate(
			{
				scrollTop: $(this).closest("form").offset().top - 200,
			},
			600
		);
	});

	/** countdown **/
	let counter=false;
	var $countdown = $(context).find(".countdown-timer").once('js_mod');
	if ($countdown.length) {
		countDownDate = new Date($countdown.data('countdown-end-date')).getTime();
		counter = setInterval(timer, 1000);
	}

	/**
	 * Prevent Google Fonts from getting loaded by Google Maps
	 */
	var head = document.querySelector("head");
	var insertBerfore = head.insertBefore;
	head.insertBefore = function (newElement, referenceElement) {
		if (!isGoogleFont(newElement)) {
			insertBerfore.call(head, newElement, referenceElement);
		}
	};
	var appendChild = head.appendChild;
	head.appendChild = function (textNode) {
		if (!isGoogleFont(textNode)) {
			return appendChild.call(head, textNode);
		}
	}

$(".stage-video .pagination-pause,.stage-video .pagination-play").on(
	"click",
	function () {
		let video = $(this).closest(".stage-video").find("video");
		let play = $(this).closest(".stage-video").find(".pagination-play");
		let pause = $(this).closest(".stage-video").find(".pagination-pause");

		if ($(this).hasClass("pagination-play")) {
			$(video).trigger("play");
			$(play).hide();
			$(pause).show();
		} else {
			$(video).trigger("pause");
			$(pause).hide();
			$(play).show();
		}
	}
);

/*
 * Set height for footer push to make footer sticky
 */
function setFooterPush() {
	var footerHeight = $(".site-footer").height("auto").outerHeight();
	$(".page-wrap").css("margin-bottom", -footerHeight);
	$(".page-wrap .push, .site-footer").css("height", footerHeight);
}

function hasScrollbar() {
	$(".page-content table").each(function () {
		var $table = $(this);

		if ($table.find("tr").width() > $table.closest(".page-content").width()) {
			if (!$table.closest(".table-scroll-wrapper").length) {
				$table.wrap("<div class='table-scroll-wrapper'></div>");
			}
		} else {
			if ($table.closest(".table-scroll-wrapper").length) {
				$table.unwrap();
			}
		}
	});
}

/*
 * Return slider options
 */
function getSliderOptions(name, element) {
	var options = {
		default: {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			adaptiveHeight: true,
		},
		fullscreen: {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
					},
				},
			],
		},
		teaserimgtwothirdslider: {
			dots: true,
			arrows: false,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
		},
		teaserimgslider: {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 850,
					settings: {
						arrows: false,
					},
				},
			],
		},
		galleryslider: {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			dots: false,
			asNavFor: ".thumb-nav",
		},
		thumbnav: {
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			asNavFor: ".gallery-slider",
			dots: false,
			focusOnSelect: true,
			infinite: true,
			centerMode: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
					},
				},
			],
		},
		video: {
			dots: true,
			arrows: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
					},
				},
			],
		},
		googlereviewslider: {
			dots: true,
			arrows: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						// arrows: true,
					},
				},
			],
		},
	};

	return options[name];
}

function addSliderPlayButton(element, slick) {
	var $slider = $(element);
	if ($slider.find(".slider-controls").length) {
		return;
	}
	var controls =
		'<button class="pagination-pause"> <span class="pause"> <svg class="progress-ring" width="42" height="42"> <circle class="circle" stroke="pink" stroke-width="2" fill="transparent" r="20" cx="21" cy="21" /> </svg> <span class="icon icon-pause" ><svg aria-hidden="true" width="10px" height="16px" viewBox="0 0 10 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" > <g stroke="none" stroke-width="1"> <g transform="translate(-473.000000, -299.000000)" fill-rule="nonzero" > <g transform="translate(473.000000, 299.000000)"> <polygon points="0 0 2 0 2 16 0 16"></polygon> <polygon points="8 0 10 0 10 16 8 16"></polygon> </g> </g> </g></svg ></span> </span> </button> <button class="pagination-play"> <span class="play"> <svg class="progress-ring" width="42" height="42"> <circle class="circle" stroke="white" stroke-width="2" fill="transparent" r="20" cx="21" cy="21" /> </svg> <span class="icon icon-play" ><svg aria-hidden="true" width="14px" height="20px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 14 20" xml:space="preserve" > <path d="M-0.1,0v20l14-10L-0.1,0z M1.6,3.2l9.5,6.7l-9.5,6.8C1.6,16.7,1.6,3.2,1.6,3.2z" ></path></svg ></span> </span> </button>';
	var sliderSpeed = slick.options.autoplaySpeed + "ms";
	var sliderSpeedWithTransition =
		slick.options.autoplaySpeed + slick.options.speed + "ms";
	var animationClass = "animate";

	$slider.find(".slick-dots").wrap('<div class="slider-controls"></div>');
	$slider.find(".slider-controls").prepend(controls);

	var $playbutton = $slider.find(".pagination-play");
	var $pauseButton = $slider.find(".pagination-pause");

	// Hide play button on start
	$playbutton.hide();

	// Start autoplay and toggle play/pause controls
	$playbutton.on("click", function () {
		var currentSlideIndex = $slider.slick("slickCurrentSlide");
		if (
			$(slick.$slides.get(currentSlideIndex))
				.find(".slide")
				.hasClass("fullsize-video")
		) {
			let $videoSlider = $(slick.$slides.get(currentSlideIndex)).find(".slide");
			$videoSlider.find("video").trigger("play");
		} else {
			$pauseButton.find(".circle").css("animationDuration", sliderSpeed);
			$pauseButton.addClass(animationClass);
		}

		$pauseButton.show();
		$slider.slick("slickPlay");
		$playbutton.hide();
	});

	// Pause autoplay and toggle play/pause controls
	$pauseButton.on("click", function () {
		var currentSlideIndex = $slider.slick("slickCurrentSlide");
		if (
			$(slick.$slides.get(currentSlideIndex))
				.find(".slide")
				.hasClass("fullsize-video")
		) {
			let $videoSlider = $(slick.$slides.get(currentSlideIndex)).find(".slide");
			$videoSlider.find("video").trigger("pause");
		}

		$slider.slick("slickPause");
		$pauseButton.hide().removeClass(animationClass);
		$playbutton.show();
	});

	// check if first slide is video then stop slick autoplay and start video
	setTimeout(function () {
		var currentSlideIndex = $slider.slick("slickCurrentSlide");
		if ($($slider.get(currentSlideIndex)).find(".slide.fullsize-video")[0]) {
			let $videoSlider = $($slider.get(0)).find(".slide.fullsize-video")[0];
			$($videoSlider).find("video").trigger("play");
			$slider.slick("slickPause");
		} else {
			// Adjust animation-duration to autoplay speed and start animation on pause button
			$pauseButton.find(".circle").css("animationDuration", sliderSpeed);
			$pauseButton.addClass(animationClass);
		}
	}, 50);

	// Restart pause button animation before change
	$slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
		if (
			$(slick.$slides.get(currentSlide))
				.find(".slide")
				.hasClass("fullsize-video")
		) {
			let $videoSlider = $(slick.$slides.get(currentSlide)).find(".slide");
			$videoSlider.find("video").trigger("pause");
		}

		if (
			$(slick.$slides.get(nextSlide)).find(".slide").hasClass("fullsize-video")
		) {
			let $videoSlider = $(slick.$slides.get(nextSlide)).find(".slide");
			$videoSlider.find("video").get(0).currentTime = 0;
		}

		$pauseButton.removeClass("animate");

		setTimeout(function () {
			if (
				!$(slick.$slides.get(nextSlide))
					.find(".slide")
					.hasClass("fullsize-video")
			) {
				$pauseButton
					.find(".circle")
					.css("animationDuration", sliderSpeedWithTransition);
				$pauseButton.addClass(animationClass);
			} else {
				$pauseButton.removeClass("animate");
			}
		}, 50);
	});

	$slider.on("afterChange", function (event, slick, currentSlide, nextSlide) {
		if (
			$(slick.$slides.get(currentSlide))
				.find(".slide")
				.hasClass("fullsize-video")
		) {
			let $videoSlider = $(slick.$slides.get(currentSlide)).find(".slide");
			$videoSlider.find("video").trigger("play");
			$slider.slick("slickPause");
		}
	});

	// Mobile fix for default behaviour that pauses autoplay on touch
	$slider.find(".slick-list").on("touchstart", function (e) {
		$pauseButton.trigger("click");
	});
	$slider.find(".slick-list").on("touchend", function () {
		$playbutton.trigger("click");
	});

	$("video").on("ended", function () {
		$slider.slick("slickPlay");
		$slider.slick("slickNext");
	});
}

function isAboveWindowBottom(element) {
	var top_of_object = element.offset().top + 5;
	var bottom_of_window = $(window).scrollTop() + $(window).height();
	if (top_of_object <= bottom_of_window) {
		return true;
	} else return false;
}

function checkRatio() {
	if ($(window).height() >= $(window).width()) {
		$(".slider-fullscreen").addClass("ratio-portrait");
		$(".stage-fullscreen").addClass("ratio-portrait");
	} else {
		$(".slider-fullscreen").removeClass("ratio-portrait");
		$(".stage-fullscreen").removeClass("ratio-portrait");
	}
}

function fadeInElements(event) {
	if (!$(".fade-in").length) {
		$(window).unbind("scroll.fadeIn");
		return false;
	}

	$(".fade-in").each(function () {
		if (isAboveWindowBottom($(this))) {
			$(this).removeClass("fade-in");
		}
	});
}

function throttle(callback, limit) {
	var wait = false;
	return function () {
		if (!wait) {
			callback.apply(null, arguments);
			wait = true;
			setTimeout(function () {
				wait = false;
			}, limit);
		}
	};
}

function initGalleries(context) {
	galleryOptions = getSliderOptions("galleryslider");
	thumbOptions = getSliderOptions("thumbnav");

	$(".gallery", context).each(function () {
		var title = $(".header-editorial h2 span").text();
		var content =
			'<div class="lightbox gallery-lightbox"><div class="title">' +
			title +
			'<a class="close-button icon icn-close mfp-close"></a></div>' +
			$(this).get(0).outerHTML +
			"</div>";

		$(this)
			.find(".js-open-gallery")
			.magnificPopup({
				items: {
					src: content,
					type: "inline",
				},
				callbacks: {
					open: function () {
						// Init sliders for overlay and set current slide
						var currentSlide = this.ev.data("slide")
							? this.ev.data("slide")
							: 0;

						galleryOptions.initialSlide = currentSlide;
						thumbOptions.initialSlide = currentSlide;

						this.contentContainer
							.find(".gallery-slider")
							.slick(galleryOptions);
						this.contentContainer.find(".thumb-nav").slick(thumbOptions);
					},
				},
			});
	});

	// Init sliders
	$(".gallery-slider", context).slick(galleryOptions);
	$(".thumb-nav", context).slick(thumbOptions);

	// Set current slide on lightbox trigger
	$(".gallery-slider", context).on(
		"afterChange",
		function (event, slick, currentSlide) {
			$(this).prev(".js-open-gallery").data("slide", currentSlide);
		}
	);
}

function initLightboxes(context) {
	$(".js-open-lightbox", context).each(function () {
		var title = $(this).attr("title");

		$(this).magnificPopup({
			type: "iframe",
			closeMarkup: '<a class="close-button icon icn-close mfp-close"></a>',
			iframe: {
				markup:
					'<div class="lightbox">' +
					'<div class="title">' +
					title +
					'<div class="mfp-close"></div></div>' +
					'<div class="mfp-iframe-scaler">' +
					'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
					"</div>" +
					"</div>",
			},
		});
	});
}

function initIFrameResizer(context) {
	if ($("iframe.resize", context).length) {
		iFrameResize({
			log: false, // Enable console logging
			enablePublicMethods: true, // Enable methods within iframe hosted page
			heightCalculationMethod: "lowestElement",
			minHeight: 300,
		});
	}
}

// Fix for IE and iPad, fit map center to markers if center has lat 0 or lng 0
function setMapCenter() {
	setTimeout(function () {
		$.each(Drupal.geolocation.maps, function (index, currentMap) {
			if (
				currentMap.getCenter().lat == 0 ||
				currentMap.getCenter().lat == 0
			) {
				currentMap.fitMapToMarkers();
				currentMap.setZoom();
			}
		});
	}, 100);
}

/**
 * Toggle slide menu
 */
function toggleSlideMenu($menu) {
	if ($menu.prev(".js-toggle-slide-select").is(":visible")) {
		$menu.slideToggle();
	}
}

/**
 * Go to slide
 */
function goToSlide(slider, slide) {
	slider.slick("slickGoTo", slide);
	updateSliderNavigation(slider, slide);
}

function timer() {
	let dayElement = '.countdown-metric.days h2';
	let hourElement = '.countdown-metric.hours h2';
	let minuteElement = '.countdown-metric.minutes h2';
	let secondElement = '.countdown-metric.seconds h2';

	// Get today's date and time
	var now = new Date().getTime();

	// Find the distance between now and the count down date
	var distance = countDownDate - now;

	// Time calculations for days, hours, minutes and seconds
	var days = Math.floor(distance / (1000 * 60 * 60 * 24));
	var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
	var seconds = Math.floor((distance % (1000 * 60)) / 1000);

	if(days > 0) {
		$(dayElement).text(makeMeTwoDigits(days));
	}
	if(hours > 0) {
		$(hourElement).text(makeMeTwoDigits(hours));
	}
	if(minutes > 0) {
		$(minuteElement).text(makeMeTwoDigits(minutes));
	}
	if(seconds > 0) {
		$(secondElement).text(makeMeTwoDigits(seconds));
	}

	// If the count down is over, write some text
	if (distance < 0) {
		clearInterval(counter);
		$('.countdown-timer').hide();
	}
}

function makeMeTwoDigits(n){
	return (n < 10 ? "0" : "") + n;
}

/**
 * Update slider navigation
 */
function updateSliderNavigation(slider, slide) {
	var $sliderNavigation = slider
		.closest(".slider-container")
		.find(".slider-navigation");
	$sliderNavigation.find("li").removeClass("is-active");
	$sliderNavigation.find("li").eq(slide).addClass("is-active");

	var activeValue = $sliderNavigation.find("li.is-active span").text();
	$sliderNavigation.find(".slide-select").text(activeValue);
}

function isGoogleFont(element) {
	if (element.children.length) {
		let status = false;
		let elements = Array.from(element.children);
		for (let child in elements) {
			status = status || isGoogleFont(elements[child]);
		}
		return status;
	} else {
		// roboto font download
		if (
			element.href &&
			element.href.indexOf("https://fonts.googleapis.com/css") === 0
		) {
			return true;
		}
		// roboto style elements
		if (
			element.tagName.toLowerCase() === "style" &&
			element.styleSheet &&
			element.styleSheet.cssText &&
			element.styleSheet.cssText.replace("\r\n", "").indexOf(".gm-style") ===
			0
		) {
			element.styleSheet.cssText = "";
			return true;
		}
		// roboto style elements for other browsers
		if (
			element.tagName.toLowerCase() === "style" &&
			element.innerHTML &&
			element.innerHTML.replace("\r\n", "").indexOf(".gm-style") === 0
		) {
			element.innerHTML = "";
			return true;
		}
		// when google tries to add empty style
		if (
			element.tagName.toLowerCase() === "style" &&
			!element.styleSheet &&
			!element.innerHTML
		) {
			return true;
		}

		return false;
	}
}

// Video Stage Position Playbutton
function setPlaybuttonPosition() {
	var stage = $(".stage-slider-fullscreen.stage-video");
	var slide = stage.find(".slick-slide .slide");
	var image = slide.find(".img-wrapper");

	var controls = stage.find(".slider-controls");
	if (image != null && image.length != 0) {
		var height = image.height();
		if ($(window).width() < 1024) {
			controls.css("position", "absolute");
			controls.css("top", height - 60 - 42 + "px");
			controls.css("padding-left", 20 + "px");
		}
		else {
			controls.css("top", "auto");
			controls.css("padding-left", 0 + "px");
		}
	}
}
})
